// Do mais privilegiado ao menos privilegiado
export const PROFILE_HIERARCHY = [
  'TRCKOWN',
  'TRCKOWNVI',
  'SERVSHAR',
  'SERVSHARVI',
  'DEALER',
  'FINACON',
  'FINACONVI',
  'SIMPlVI',
]

const PROFILE_ROLE_FIELDS = ['name', 'code', 'role', 'profile', 'description']

const normalizeRoleKey = value => {
  if (value == null || value === '') return null
  return String(value).trim().toUpperCase()
}

export const getProfileRoleKey = profile => {
  if (!profile) return null

  for (const field of PROFILE_ROLE_FIELDS) {
    const normalized = normalizeRoleKey(profile[field])
    if (normalized && PROFILE_HIERARCHY.includes(normalized)) {
      return normalized
    }
  }

  return null
}

export const getProfileHierarchyIndex = roleKey => {
  const index = PROFILE_HIERARCHY.indexOf(roleKey)
  return index === -1 ? PROFILE_HIERARCHY.length : index
}

export const sortProfilesByHierarchy = profiles => {
  if (!Array.isArray(profiles) || profiles.length === 0) return []

  return [...profiles].sort((a, b) => {
    const indexA = getProfileHierarchyIndex(getProfileRoleKey(a))
    const indexB = getProfileHierarchyIndex(getProfileRoleKey(b))

    if (indexA !== indexB) return indexA - indexB

    const labelA = (a.description || a.name || '').toLowerCase()
    const labelB = (b.description || b.name || '').toLowerCase()
    return labelA.localeCompare(labelB)
  })
}

export const mapProfilesToSelectOptions = profiles =>
  sortProfilesByHierarchy(profiles).map(profile => ({
    label: profile.description || profile.name || '',
    value: profile.id,
  }))
